import React, { useEffect, useState } from 'react';
import AdminTable from 'common/AdminTable';
import { getRequest, deleteRequest } from 'apis/ApiInstence';
import { FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const List = () => {
  const [galleryData, setGalleryData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchGallery = async () => {
    try {
      const response = await getRequest('galleries');
      if (response?.data) {
        setGalleryData(response.data);
      } else {
        setGalleryData([]);
      }
    } catch (error) {
      console.error('Error fetching gallery:', error);
      setGalleryData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this image?')) {
      try {
        const response = await deleteRequest(`galleries/${id}`);
        if (response?.status === 200) {
          setGalleryData((prev) => prev.filter((img) => img.id !== id));
        } else {
          alert('Failed to delete image.');
        }
      } catch (error) {
        console.error('Error deleting image:', error);
        alert('Failed to delete image.');
      }
    }
  };

  const tableHeaders = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'Name', accessor: 'name' },
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) => {
        const imageName = row.original.image;
        const imageUrl = imageName
          ? `${process.env.REACT_APP_BACKEND}gallery/${imageName}`
          : '/Images/default.jpg';

        return (
          <img
            src={imageUrl}
            alt={row.original.name}
            width={100}
            height={100}
            style={{ objectFit: 'cover', borderRadius: 8 }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/Images/default.jpg';
            }}
          />
        );
      },
    },
    {
      Header: 'Action',
      accessor: 'action',
      Cell: ({ row }) => (
        <button
          className="btn btn-danger btn-sm"
          onClick={() => handleDelete(row.original.id)}
        >
          <FaTrash /> Delete
        </button>
      ),
    },
  ];

  useEffect(() => {
    fetchGallery();
  }, []);

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4 d-flex justify-content-between align-items-center mb-4">
        <h4 className="text-white font-weight-bold mb-0">Gallery List</h4>
        <Link className="btn btn-light font-weight-bold shadow-sm" to="/gallery/add" style={{ borderRadius: '8px', padding: '8px 16px', color: '#015198' }}>
          <i className="fa fa-plus mr-2"></i>
          Add New Image
        </Link>
      </div>

      {loading ? (
        <div className="text-white text-center mt-4">Loading...</div>
      ) : galleryData.length > 0 ? (
        <AdminTable tableHeaders={tableHeaders} tableData={galleryData} />
      ) : (
        <div className="text-white text-center mt-4">No gallery images found.</div>
      )}
    </div>
  );
};

export default List;
